module.exports = __webpack_public_path__ + "static/img/head.b428142.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/head.png
// module id = u6Uw
// module chunks = 1